import type { Translations } from '@layers/app/stores/types/locale.ts'

import { LocaleApiService } from '@layers/web/services/locale-api.ts'
import { isPreviewHostname } from '@layers/web/utils/preview.ts'

export default defineNuxtPlugin(async (nuxtApp) => {
  const { public: { previewMode } } = useRuntimeConfig()

  // previewMode is a build-time flag from an external deploy pipeline; the hostname
  // fallback keeps preview.* domains fetching live translations even if that flag is wrong.
  const isPreview = previewMode || isPreviewHostname(useRequestURL().hostname)

  if (!isPreview) {
    return
  }

  const cachedTranslations = useState<Translations | null>('preview-translations', () => null)

  if (!cachedTranslations.value) {
    cachedTranslations.value = await LocaleApiService.fetchRuntimeTranslations({ cacheReload: true })
  }

  // @ts-expect-error - i18n:register is a nuxt-i18n-micro hook not in RuntimeNuxtHooks
  nuxtApp.hook('i18n:register', (_registerModule: unknown, locale: string) => {
    if (!cachedTranslations.value) {
      return
    }

    // registerModule (nuxt-i18n-micro's own callback) merges into the *route's* cache
    // bucket, but disablePageLocales makes every t()/data-i18n lookup read the 'general'
    // bucket instead (see nuxt-i18n-micro's getPluginRouteName) - so registerModule's
    // writes are never read back. Merge into 'general' directly so live edits actually
    // reach what gets rendered.
    // @ts-expect-error - $i18n is provided by nuxt-i18n-micro, untyped on NuxtApp
    nuxtApp.$i18n.helper.mergeTranslation(locale, 'general', cachedTranslations.value, true)
  })
})
